<div class="world-map">
  <div
    id="map"
    leaflet
    [leafletOptions]="mapOptions"
    (leafletMapReady)="onMapReady($event)"
    (leafletMapMoveEnd)="onMoveOrZoomEnd()"
    (leafletClick)="onMapClick()"></div>
  @if (isLoading) {
    <div class="loading-container">
      <app-loader />
    </div>
  }
  <div class="display-more-wrapper">
    <div class="indicator">
      <span class="number">{{ videos.length }} </span>
      <span>{{ 'browse.map.resultsDisplayed' | translate }}</span>
      @if (!isLoading && !!totalAvailableVideos) {
        <span> {{ 'browse.map.outOf' | translate }} </span>
        <span class="number">{{ totalAvailableVideos }}</span>
        <span> {{ 'browse.map.found' | translate }} </span>
      }
      @if (isLoading) {
        <p style="font-size: 0.7em" translate>browse.map.loading</p>
      }
    </div>
    <button
      class="display-more-btn"
      [ngClass]="{
        'display-none': isFull || isLoading,
      }"
      (click)="onDisplayMore()">
      <span class="icon icon-plus"></span>
      <span class="display-more-text">{{
        'browse.displayMore' | translate
      }}</span>
    </button>
  </div>
</div>
